var rtl_default = {
  "rtl": "_6-EPN",
  "ltr": "BB1zQ"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
